/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import classes from './LanguageDisplay.module.css';
import { Text, Avatar, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { IconQuestionMark } from '@tabler/icons-react';

/* -------------------------------------------------------------------------- */
/*                                  Constants                                 */
/* -------------------------------------------------------------------------- */
const LANGUAGE_COUNTRY_MAP: { [key: string]: string } = {
	en: 'us',
	fr: 'fr',
	es: 'es',
};

const LANGUAGE_I18N_MAP: {
	[key: string]: (t: any) => string;
} = {
	fr: (t) => t('global.french'),
	en: (t) => t('global.english'),
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const LanguageDisplay = ({
	language,
}: {
	language: string;
}) => {
	const { t } = useTranslation();

	const getCountryCode = (language: string) =>
		LANGUAGE_COUNTRY_MAP[language] || 'fr';

	const getLanguageName = (language: string) =>
		LANGUAGE_I18N_MAP[language]?.(t) ||
		t('global.french');

	return (
		<Group gap={'10px'}>
			<Avatar
				className={classes.logoCountry}
				radius={'xl'}
				src={`https://flagcdn.com/w40/${getCountryCode(language || 'fr')}.png`}
				size={'xs'}
			>
				<IconQuestionMark />
			</Avatar>
			<Text className={classes.value}>
				{getLanguageName(language || 'fr')}
			</Text>
		</Group>
	);
};
